import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Collapse, Typography } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 100%;
  width: 100%;
  margin: 0 auto;
  direction: rtl;
`;

export const Header = styled.div`
  margin-bottom: 32px;

  .main-title {
    color: #1a295a;
    margin-bottom: 8px;
    font-weight: ${FONT_WEIGHT.extremeBold};
  }

  .sub-title {
    color: #1a295a;
    font-weight: ${FONT_WEIGHT.extremeBold};
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 16px;
    .main-title {
      font-size: 18px;
    }

    .sub-title {
      font-size: 16px;
    }
  }
`;

export const Intro = styled.div`
  margin-bottom: 40px;
  font-size: 18px;
  line-height: 1.8;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.light};

  .ant-typography {
    margin: 0;
  }

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;

export const SectionTitle = styled(Typography.Title)`
  && {
    margin-bottom: 10px;
    color: #1a295a;
    font-size: 18px;
    font-weight: ${FONT_WEIGHT.extremeBold};
  }

  @media screen and (max-width: 768px) {
    && {
      font-size: 16px;
    }
  }
`;

export const Features = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  @media screen and (max-width: 768px) {
    gap: 16px;
  }
`;

export const FeatureItem = styled.div`
  display: flex;
  align-items: flex-start;
  font-size: 18px;
  gap: 16px;

  .highlight {
    color: #ce6239; // orange accent
    font-size: 18px;
    display: block;
    margin-bottom: 4px;
    font-weight: ${FONT_WEIGHT.extremeBold};
  }

  .ant-typography {
    margin: 0;
    font-weight: ${FONT_WEIGHT.light};
  }
  @media screen and (max-width: 768px) {
    font-size: 14px;

    .highlight {
      font-size: 14px;
    }
  }
`;

export const NumberCircle = styled.div`
  min-width: 32px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #001f54;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-size: 14px;
  font-weight: ${FONT_WEIGHT.extremeBold};

  @media screen and (max-width: 768px) {
    min-width: 24px;
    width: 24px;
    height: 24px;
    font-size: 12px;
  }
`;

/* --- Stats Section --- */
export const Stats = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 8px;
  margin: 48px 0;

  @media screen and (max-width: 900px) {
    grid-template-columns: repeat(auto-fit, minmax(49%, 49%));
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(100%, 1fr));
  }
`;

export const StatCard = styled.div`
  background: #fbf5f1;
  border-radius: 4px;
  padding: 24px;
  text-align: center;

  .stat-number {
    display: block;
    font-size: 32px;
    color: #ce6239;
    margin-bottom: 0px;
    font-weight: ${FONT_WEIGHT.extremeBold};
  }

  .stat-label {
    font-size: 14px;
    color: #1a295a;
    font-weight: ${FONT_WEIGHT.light};
  }

  @media screen and (max-width: 768px) {
    padding: 16px;
    .stat-number {
      font-size: 18px;
    }

    .stat-label {
      font-size: 14px;
    }
  }
`;

/* --- Footer Section --- */
export const Footer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  margin-top: 32px;

  .footer-text {
    color: #1a295a;
    font-size: 22px;
    font-weight: ${FONT_WEIGHT.extremeBold};
  }

  .plus-icon {
    font-size: 18px;
    color: #ce6239;
    font-weight: ${FONT_WEIGHT.extremeBold};
  }

  @media screen and (max-width: 768px) {
    margin-top: 16px;
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;

    .footer-text {
      font-size: 18px;
    }

    .plus-icon {
      font-size: 16px;
    }
  }
`;

export const IconWrapper = styled.div`
  width: 40px;
  min-width: 40px;
  height: 40px;
  background: #fbf5f1;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: ${FONT_WEIGHT.extremeBold};
  border: 2px solid #ce6239;
`;

export const AvatarWrapper = styled.img`
  object-fit: contain;

  @media screen and (max-width: 768px) {
    width: 60px;
    height: auto;
  }
`;

export const CollapseWrapper = styled(Collapse)`
  background: #fbf5f1;
  border-radius: 4px;
  padding: 16px;

  &.ant-collapse.ant-collapse-icon-position-start.ant-collapse-rtl.custom-collapse {
    background: transparent;
    padding: 0;
    border: none;

    .ant-collapse-item.ant-collapse-no-arrow,
    .ant-collapse-header {
      background: transparent;
      border: none;
    }
  }
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const UserWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-block: 16px;
`;
export const UserContent = styled.div`
  .title {
    margin: 0;
    color: #1a295a;
    font-size: 22px;
    font-weight: ${FONT_WEIGHT.regular};
  }

  .sub-text {
    margin: 0;
    display: block;
    width: 100%;
    color: #1a295a;
    font-size: 18px;
    font-weight: ${FONT_WEIGHT.regular};
  }

  @media screen and (max-width: 768px) {
    .title {
      font-size: 18px;
    }

    .sub-text {
      font-size: 14px;
    }
  }
`;

export const UserContentBlock = styled.div`
  font-size: 20px;
  line-height: 1.8;
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.light};

  .ant-typography {
    margin: 0;
  }

  .bold {
    font-weight: ${FONT_WEIGHT.medium};
    color: #1a295a;
  }

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;
